export default {
  GET_ITEMS(state) {
    return state.interventions
  },
  GET_ITEMS_HAS_INVOICE(state) {
    return state.interventionsHasInvoice
  },
  GET_ITEMS_DOESNT_HAVE_INVOICE(state) {
    return state.interventionsDoesntHaveInvoice
  },
  GET_ITEM(state,id) {
    state.interventions.find((item) => item.id == id)
  },
  GET_ITEMS_ARTISAN(state) {
    return state.interventionsByArtisan
  },
  GET_ITEMS_NBR_INTERVENTION(state) {
    return state.usersNbrsInterventions
  },

  GET_ITEMS_HISTORIQUES_BY_INTERVENTION(state) {
    return state.historiquesByIntervention
  },
}
